/**
 * @fileoverview Dashboard component that serves as the main page layout
 * @version 1.0.0
 * 
 * @component Dashboard
 * @description Main dashboard component that displays the application header and content
 * 
 * @example
 * // Basic usage
 * import Dashboard from './Dashboard';
 * 
 * function App() {
 *   return <Dashboard />;
 * }
 * 
 * @returns {JSX.Element} Dashboard component with header and main content
 */

import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MainContent from '../components/MainContent';
import useLambdaData from '../hooks/useLambdaData';


const Dashboard = () => {
    // Get data, loading state and refresh function from custom hook
    // const { data, loading, refreshData } = useLambdaData();

    return (
        <div>
            <Header />
            {/* Conditional rendering based on loading state */}
            <MainContent />
            {/* {loading ? <p>Loading...</p> : <MainContent data={data} onRefresh={refreshData} />} */}
            <Footer />
        </div>
    );
    
};

export default Dashboard;
